<template>
  <div class="chat-icon" @click="togglePopup">
    <div class="content">
      <img v-if="globalData.setting.live_chat.logo" :src="globalData.setting.live_chat.logo" class="live-logo" :class="{'rotate-avatar': globalData.unread_count > 0 && !globalData.isPopupOpen}" alt=""/>
      <img v-else class="default-logo" :src="'/icons/logo/LiveChat.svg'" :class="{'rotate-avatar': globalData.unread_count > 0 && !globalData.isPopupOpen}" alt=""/>
      <div v-if="globalData.unread_count > 0 && !globalData.isPopupOpen" class="unread-box">
      </div>
      <div v-show="globalData.is_show_notification && !globalData.isPopupOpen" class="unread-message">
        <div style="font-weight: 600">
          {{globalData.setting.live_chat.name?.length > 15 ? globalData.setting.live_chat.name.substring(0,15) + '...' : globalData.setting.live_chat.name}}
        </div>
        <span style="font-size: 13px">{{globalData.notify_content}}</span>
        </div>
    </div>
  </div>
</template>

<script>
import util from "@/lib/util";
import api from "@/lib/callAPI";
export default {
  name: 'ChatIcon',
  mounted() {
    const body = {
      conversation_id: this.globalData.browser_id,
    }
    api.get('/api/conversation/getLastMessageFrom', body).then(response=>{
      let local_message_id = localStorage.getItem('last_message_id');
      if (response.success === true && ((response?.data?.id === this.globalData.account_id && response?.data?.message_id !== local_message_id) || !response.data.id)) {
        util.changeSizeNotification(1)
        this.globalData.is_show_notification = true;
        this.globalData.unread_count = 1;
        this.globalData.notify_content = this.globalData.setting.greeting;
        if (this.globalData.notify_content?.length > 50) {
          let element = document.querySelector('.unread-message');
          if (element) {
            element.style.width = '300px';
          }
        }
        if (response.data.message_id){
          this.last_message_id =  response.data.message_id;
        }
      }
    })

  },

  data(){
    return {
      content:'Bạn có tin nhắn mới',
      last_message_id: '',
    }
  },
  methods: {
    togglePopup() {
      if(this.globalData.unread_count > 0){
        let data_pop = {
          type: 'change-size-notification',
          data : 0,
        }
        window.parent.postMessage(data_pop,  '*');
      }
      this.globalData.unread_count = 0;
      this.globalData.is_show_notification = false;
      this.globalData.notify_content = 'Bạn có tin nhắn mới';
      this.$emit('toggle-popup');
      if(this.last_message_id){
        localStorage.setItem('last_message_id', this.last_message_id);
      }
    },
  },
};
</script>

<style lang="scss">

.chat-icon{
  cursor: pointer;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  position: fixed;
  bottom: 0;
  right: 0;
}

.content{
  position: relative;
}

.live-logo{
  background-size: cover;
  background-repeat: no-repeat;
  width: 56px;
  height: 56px;
  border-radius: 50%;
}

.rotate-avatar{
animation: rotate-shake 0.5s ease-in-out infinite;
}

@keyframes rotate-shake {
  0% { transform: rotate(0); }
  25% { transform: rotate(-8deg); }
  50% { transform: rotate(8deg); }
  75% { transform: rotate(-8deg); }
  100% { transform: rotate(0); }
}

.default-logo{
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-size: cover;
  background-repeat: no-repeat;
}
.unread-box{
  position: absolute;
  top: -3px;
  right: 0;
  width: 18px;
  height: 18px;
  background-color: red;
  color: white;
  text-align: center;
  font-size: 11px;
  line-height: 18px;
  border-radius: 50%;
  border: 3px solid white;
}

.unread-message{
  position: absolute;
  background-color: #3484f0;
  bottom: 0px;
  right: 80px;
  min-width: 180px;
  word-wrap: break-word;
  //width: 300px;
  //height: 100%;
  padding: 8px 10px;
  border-radius: 12px;
  color: white;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  .child{
    width: 8px;
    height: 8px;
    margin-right: 8px;
    background-color: lawngreen;
    border-radius: 50%;
  }
}

.unread-message:before {
  background-color: #3484f0;
  position: absolute;
  content: "";
  height: 16px;
  width: 15px;
  bottom: 20px;
  right: -15px;
  transform: translate(-50%) rotate(45deg);
}
.unread{
  animation: fade 2s infinite;
}
</style>
